
import axios from 'axios';
import index from "@/components/home/Index.vue";
import IssueIndex from "@/components/issues/Index.vue";

const routes = [
  {
    path: "/",
    redirect: "/campaign/2024techinside",
  },
  {
    path: "/campaign",
    redirect: "/campaign/2024techinside",
  },
  {
    path: "/campaign/2024techinside",
    name: "index",
    title: "Zerone",
    component: index,
  },
  {
    path: "/campaign/issues/:alias",
    name: "issues",
    title: "Zerone",
    component: IssueIndex,
  },
  {
    path: "/404",
    name: "404",
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

export default routes;
